import { render, staticRenderFns } from "./video_details.vue?vue&type=template&id=395548c7&scoped=true&"
import script from "./video_details.vue?vue&type=script&lang=js&"
export * from "./video_details.vue?vue&type=script&lang=js&"
import style0 from "./video_details.vue?vue&type=style&index=0&id=395548c7&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395548c7",
  null
  
)

export default component.exports